import React, { useState } from "react";
import { ClipboardList, ChevronUp, ChevronDown, Copy, Check } from "lucide-react";

import item1 from "../Assets/Food.svg";

export default function OrderSummary({
  isDelivered,
  orderId,
  products,
  pricing,
  merchantStatus,
  fetchOrderDetails,
}) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(orderId);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="bg-white max-w-md mt-4 mb-6 mx-4 rounded-xl shadow p-4 space-y-4">

      <div className="flex items-start gap-4">
        <div className="p-3 rounded-full bg-gray-100">
          <ClipboardList size={18} />
        </div>

        <div className="flex-1">
          <p className="font-semibold">Order Summary</p>

          <div className="flex items-center gap-2 mt-1">
            <p className="text-sm text-gray-500">Order ID: {orderId}</p>

            <button
              onClick={handleCopy}
              className="p-1 rounded hover:bg-gray-100"
            >
              {copied ? (
                <Check size={16} className="text-orange-600" />
              ) : (
                <Copy size={16} className="text-gray-600" />
              )}
            </button>
          </div>
        </div>

        <button
          onClick={() => {
            setOpen((prev) => {
              const next = !prev;
              if (next && !loaded) {
                fetchOrderDetails();
                setLoaded(true);
              }
              return next;
            });
          }}
          className="p-2 rounded-full hover:bg-gray-100"
        >
          {open ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
        </button>
      </div>


      {open && (
        <div className="space-y-4">
          {/* PRODUCTS */}
          {products.length > 0 && (
            <>
              <div className="space-y-3">
                {products.map((item) => (
                  <div key={item.id} className="flex items-center gap-3">
                    <img
                      src={item.image?.trim() ? item.image : item1}
                      alt={item.name}
                      className="w-14 h-14 rounded-lg border object-cover"
                    />

                    <div className="flex-1">
                      <p className="text-sm font-medium">{item.name}</p>
                      <p className="text-xs text-gray-500">
                        Qty: {item.qty} × ₹
                        {Number(item.unitPrice).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </p>
                    </div>

                    <p className="text-sm font-semibold">
                      ₹
                      {Number(item.itemTotal).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </p>
                  </div>
                ))}
              </div>

              <hr />
            </>
          )}

          {/* PRICING */}
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span>Item total</span>
              <span>₹{pricing.subTotal}</span>
            </div>

            <div className="flex justify-between">
              <span>CGST</span>
              <span>₹{pricing.cgst}</span>
            </div>

            <div className="flex justify-between">
              <span>SGST</span>
              <span>₹{pricing.sgst}</span>
            </div>

            <div className="flex justify-between">
              <span>Delivery charge</span>
              <span className="text-orange-600">FREE</span>
            </div>

            <hr />

            <div className="flex justify-between font-semibold">
              <span>Paid via {pricing.paymentMode}</span>
              <span>₹{pricing.total}</span>
            </div>
          </div>

          <hr />

          {/* STATUS */}
          <div className="text-sm font-medium text-orange-600">
            Payment successful via {pricing.paymentMode} •{" "}
            {merchantStatus === "successful" ||
            merchantStatus === "delivered"
              ? "Order delivered"
              : "Order confirmed"}
          </div>

          {products.length === 0 && (
            <p className="text-xs text-gray-400 text-center">
              Item details will appear once available
            </p>
          )}
        </div>
      )}
    </div>
  );
}
